import React, { useEffect, useMemo, useState } from "react";
import "./Rewards.css";

const API_BASE = "https://api-2026.fikacreatives.co";

const cafes = [
  {
    id: "a6d2369f-3d16-4ec4-a4be-93a53dfc7ce0",
    name: "FNF Coffee & Kicks",
    icon_image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQR60PJNCEbQ1O1V3kZlgg4YUWadFpDBSpA-g&s",
    cafe_image:
      "https://s3-media0.fl.yelpcdn.com/bphoto/fq_vXc6kdZUwpzfUXVYCvQ/o.jpg",
    city: "Los Angeles, CA",
    about:
      "FNF Coffee & Kicks is a community-forward cafe space blending coffee culture, design, and streetwear energy. It’s a great place to work, meet, and catch up with friends.",
    specials: [
      {
        id: "cinnamon-toast-swirl",
        name: "Cinnamon Toast Swirl",
        image:
          "https://d1w7312wesee68.cloudfront.net/5OK9y6Bso3Camu5siy2EMLjKDFU6JtFUtbKMFTB0KL4/resize:fit:720:720/plain/s3://toasttab/menu_service/restaurants/a6e763bb-1911-414f-a508-0ad1ce03ada0/MenuItem/46fa5e6f-2718-426b-ab19-2fbbb022754e.jpg",
        description:
          "A nostalgic mix of cinnamon, brown sugar, and espresso. Like the cereal—but grown up.",
      },
      {
        id: "lychee-calpico",
        name: "Lychee Calpico Matcha",
        image:
          "https://d1w7312wesee68.cloudfront.net/ogyE4CQW18H2YvSOKuxhJIJASCHHU2t_bdwxDEZtbbU/resize:fit:720:720/plain/s3://toasttab/menu_service/restaurants/a6e763bb-1911-414f-a508-0ad1ce03ada0/MenuItem/9d24fced-99ea-4565-bef8-f6f9527bf619.jpg",
        description:
          "Sweet lychee blended with tangy Calpico for a bright, fruity, and effervescent treat. Light, refreshing, and delightfully playful. Caffeine-free.",
      },
      {
        id: "air-max-foam",
        name: "Air Max Foam",
        image:
          "https://d1w7312wesee68.cloudfront.net/3x9BbtZGDhWUfVsyGpnIVh4SB75ij6H4GEQRwRVieRo/resize:fit:720:720/plain/s3://toasttab/menu_service/restaurants/a6e763bb-1911-414f-a508-0ad1ce03ada0/MenuItem/3911ff70-decf-4171-aa35-f38e3ed7fbb0.jpg",
        description:
          "Our signature: Just Brew it Cold Brew topped with whipped cold foam and a subtle vanilla flavor boost. Feels like walking on clouds.",
      },
    ],
    space: {
      description:
        "Warm, social, and stylish. A strong choice for casual work sessions, quick hangs, or a more creative coffee stop.",
      vibeTags: ["Creative", "Community", "Casual work spot", "Stylish"],
    },
  },
  {
    id: "e98a95ff-c067-4fad-96cb-ac4e6fad6bf6",
    name: "Good Intentions Coffee",
    icon_image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH0kOvABqND_-IMnAIo2dPMSKp-8qi8O3f5Q&s",
    cafe_image:
      "https://s3-media0.fl.yelpcdn.com/bphoto/IglLZQPQMhZTyFcW7Ipm6Q/o.jpg",
    city: "Los Angeles, CA",
    about:
      "Good Intentions Coffee is a neighborhood specialty coffee shop known for its thoughtfully crafted drinks, quality beans, and welcoming local atmosphere. It’s a cozy place to stop in for a great espresso, meet a friend, or spend a quiet moment enjoying a well-made cup of coffee.",
    specials: [
      {
        id: "japanese-breakfast-latte",
        name: "Japanese Breakfast Latte",
        image: "https://your-image-url.com/japanese-breakfast-latte.jpg",
        description:
          "A smooth, cozy latte inspired by Japanese breakfast flavors.",
      },
      {
        id: "pandan-latte-special",
        name: "Pandan Latte Special",
        image: "https://your-image-url.com/pandan-latte-special.jpg",
        description:
          "A fragrant latte with pandan notes and a lightly sweet finish.",
      },
      {
        id: "fresh-pastries-seasonal-offerings",
        name: "Fresh pastries and seasonal drink offerings",
        image: "https://your-image-url.com/fresh-pastries-seasonal-offerings.jpg",
        description:
          "Fresh pastries and rotating seasonal drinks depending on availability.",
      },
    ],
    space: {
      description:
        "Cozy, relaxed, and neighborhood-oriented. A comfortable spot for quiet coffee breaks, casual meetups, or short laptop sessions with a warm, inviting vibe.",
      vibeTags: ["Cozy", "Neighborhood", "Relaxed", "Specialty coffee"],
    },
  },
  {
    id: "bf4af7d7-774c-4818-82e8-f2046bd3870c",
    name: "Little Miss Cafe",
    icon_image:
      "https://images.squarespace-cdn.com/content/v1/63af3c2cd3d6ed1f96243138/d7acff39-eae3-4583-9446-1089b32adaf3/Untitled-1.png?format=1500w",
    cafe_image:
      "https://images.squarespace-cdn.com/content/v1/63af3c2cd3d6ed1f96243138/065a9e79-8c19-4a85-9178-709b27fe8423/timeline-215.jpg",
    city: "Los Angeles, CA",
    about:
      "Little Miss Cafe on Pico Blvd is a cozy neighborhood coffee shop known for its playful specialty drinks, creative flavors, and friendly atmosphere. The cafe blends classic espresso craft with fun seasonal creations, making it a great stop for coffee lovers looking for something unique.",
    specials: [
      {
        id: "princess-cake-latte",
        name: "Princess Cake Latte",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRM_SkxllAlYQqOzxyA7krMt836HvDtznPjxA&s",
        description:
          "A whimsical latte inspired by the classic Swedish princess cake, featuring soft almond and vanilla notes with a lightly sweet, dessert-like finish.",
        expiration: "Available until end of March",
      },
      {
        id: "guinness-cold-brew",
        name: "Carrot Cake Latte",
        image:
          "https://s3-media0.fl.yelpcdn.com/bphoto/5YaSFWBJ6_KuK7JrJUsEaw/o.jpg",
        description:
          "A cozy dessert in a cup. Espresso and steamed milk blended with warm cinnamon, nutmeg, and brown sugar, finished with a hint of vanilla and creamy foam. Sweet, spiced, and comforting—just like a slice of carrot cake.",
        expiration: "Available until end of March",
      },
    ],
    space: {
      description:
        "Bright, playful, and neighborhood-friendly. A relaxed stop for catching up with friends, grabbing a specialty drink, or enjoying a casual coffee break along Pico.",
      vibeTags: ["Playful", "Neighborhood spot", "Casual", "Specialty drinks"],
    },
  },
  {
    id: "the-union-dtla",
    name: "The Union Cowork",
    icon_image:
      "https://lh3.googleusercontent.com/p/AF1QipO8vpdfhIKCzknPKlqJz1t1tacf3GWyXG0N8h_T=s1360-w1360-h1020-rw",
    cafe_image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMKRvgAnfi7EJvJ8pKPpmI3BWEC5-37D6A8A&s",
    city: "Los Angeles, CA",
    about:
      "The Union Cowork is a thoughtfully designed coworking space in Downtown Los Angeles built for creatives, entrepreneurs, and remote workers. With a balance of productivity and community, it offers an inspiring environment to focus, collaborate, and connect with like-minded individuals in the heart of DTLA.",
    specials: [
      {
        id: "day-pass-access",
        name: "Day Pass Access",
        image: "https://your-image-url.com/day-pass.jpg",
        description:
          "Flexible day passes for creatives looking for a productive workspace without long-term commitment.",
      },
      {
        id: "community-events",
        name: "Community Events & Workshops",
        image: "https://your-image-url.com/community-events.jpg",
        description:
          "Regular events, panels, and workshops designed to foster collaboration and creative growth.",
      },
      {
        id: "coffee-and-tea",
        name: "Complimentary Coffee & Tea",
        image: "https://your-image-url.com/coffee-tea.jpg",
        description:
          "Enjoy complimentary coffee and tea to keep you energized throughout your workday.",
      },
    ],
    space: {
      description:
        "Modern, airy, and community-driven. The Union blends clean design with collaborative energy, making it ideal for deep work sessions, casual meetings, and creative networking in DTLA.",
      vibeTags: [
        "Modern",
        "Collaborative",
        "Creative",
        "Community-driven",
        "Productive",
      ],
    },
  },
];

async function readJsonSafely(r) {
  const ct = r.headers.get("content-type") || "";
  if (ct.includes("application/json")) return await r.json();
  const text = await r.text();
  return {
    ok: false,
    error: `Expected JSON but got ${ct || "unknown"}: ${text.slice(0, 120)}`,
  };
}

function normalizeSpecials(cafe) {
  if (!cafe) return cafe;

  const normalizedSpecials = Array.isArray(cafe.specials)
    ? cafe.specials.map((item, idx) => {
        if (typeof item === "string") {
          return {
            id: `${cafe.id || "cafe"}-special-${idx}`,
            name: item,
            image: cafe.cafe_image || "",
            description: "",
            expiration: "",
          };
        }

        return {
          id: item.id || `${cafe.id || "cafe"}-special-${idx}`,
          name: item.name || `Special ${idx + 1}`,
          image: item.image || cafe.cafe_image || "",
          description: item.description || "",
          expiration: item.expiration || "",
        };
      })
    : [];

  return {
    ...cafe,
    specials: normalizedSpecials,
  };
}

function formatTrialEnd(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export default function RewardsPage() {
  const [isRewardModalOpen, setIsRewardModalOpen] = useState(false);
  const [isSubscribeModalOpen, setIsSubscribeModalOpen] = useState(false);
  const [isTrialInfoModalOpen, setIsTrialInfoModalOpen] = useState(false);
  const [isRedeemNowModalOpen, setIsRedeemNowModalOpen] = useState(false);
  const [redeemNowCafe, setRedeemNowCafe] = useState(null);
  const [redeemNowTotal, setRedeemNowTotal] = useState("");
  const [redeemNowSubmitting, setRedeemNowSubmitting] = useState(false);
  const [redeemNowError, setRedeemNowError] = useState("");
  const [redeemNowSuccess, setRedeemNowSuccess] = useState(false);

  const [selectedCafe, setSelectedCafe] = useState(null);
  const [selectedDrink, setSelectedDrink] = useState(null);
  const [activeCafeTab, setActiveCafeTab] = useState("about");

  const [loadingReward, setLoadingReward] = useState(true);
  const [rewardError, setRewardError] = useState("");

  const [redirecting, setRedirecting] = useState(false);
  const [rewardState, setRewardState] = useState({
    showCoupon: false,
    canRedeemNow: false,
    lockReason: "not_eligible",
    alreadyRedeemed: false,
    membership: {
      personStatus: null,
      subscriptionStatus: null,
      trialEndsAt: null,
    },
    reward: null,
  });

  useEffect(() => {
    let alive = true;

    async function loadRewardState() {
      setLoadingReward(true);
      setRewardError("");

      try {
        const r = await fetch(`${API_BASE}/api/redeem/active`, {
          method: "GET",
          credentials: "include",
          cache: "no-store",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await readJsonSafely(r);

        if (!alive) return;

        if (!r.ok || !data?.ok) {
          setRewardError(data?.error || `Failed to load (${r.status})`);
          return;
        }

        setRewardState({
          showCoupon: Boolean(data?.rewardVisibility?.showCoupon),
          canRedeemNow: Boolean(data?.rewardVisibility?.canRedeemNow),
          lockReason: data?.rewardVisibility?.lockReason || "not_eligible",
          alreadyRedeemed: Boolean(data?.already_redeemed),
          membership: data?.membership || {
            personStatus: null,
            subscriptionStatus: null,
            trialEndsAt: null,
          },
          reward: data?.reward || null,
        });
      } catch (err) {
        if (!alive) return;
        setRewardError(err?.message || "Failed to load rewards.");
      } finally {
        if (!alive) return;
        setLoadingReward(false);
      }
    }

    loadRewardState();

    return () => {
      alive = false;
    };
  }, []);

  const cafesByCity = useMemo(() => {
    const map = new Map();

    cafes.forEach((c) => {
      const normalizedCafe = normalizeSpecials(c);
      const key = normalizedCafe.city || "Qualifying Cafes";

      if (!map.has(key)) {
        map.set(key, []);
      }

      map.get(key).push(normalizedCafe);
    });

    return Array.from(map.entries());
  }, []);

  const showCoupon = rewardState.showCoupon;
  const canRedeemNow = rewardState.canRedeemNow;
  const lockReason = rewardState.lockReason;

  const isMissingPaymentMethod = lockReason === "missing_payment_method";
  const isTrialLocked = lockReason === "trial_not_finished";

  const promoTitle =
    rewardState.reward?.title || "20% Off Fika Welcome Discount";
  const trialEndsLabel = formatTrialEnd(rewardState.membership?.trialEndsAt);

  const closeRewardModal = () => setIsRewardModalOpen(false);
  const closeSubscribeModal = () => setIsSubscribeModalOpen(false);
  const closeTrialInfoModal = () => setIsTrialInfoModalOpen(false);
  const buttonLabel = (() => {
    if (canRedeemNow) return "Redeem reward";
    if (isMissingPaymentMethod) return "Start membership";
    if (isTrialLocked) return "Activate discount";
    return "Redeem now";
  })();
  
  const handlePromoClick = () => {
    if (canRedeemNow) {
      setIsRedeemNowModalOpen(true);
      return;
    }

    if (isMissingPaymentMethod) {
      setIsSubscribeModalOpen(true);
      return;
    }

    if (isTrialLocked) {
      setIsTrialInfoModalOpen(true);
      return;
    }

    setIsRedeemNowModalOpen(true);
  };

  const closeRedeemNowModal = () => {
    setIsRedeemNowModalOpen(false);
    setRedeemNowCafe(null);
    setRedeemNowTotal("");
    setRedeemNowError("");
    setRedeemNowSuccess(false);
  };

  const handleRedeemNow = async () => {
    if (!redeemNowCafe) { setRedeemNowError("Please select a cafe."); return; }
    const amount = parseFloat(redeemNowTotal);
    if (!Number.isFinite(amount) || amount <= 0) { setRedeemNowError("Please enter a valid total."); return; }
    setRedeemNowSubmitting(true);
    setRedeemNowError("");
    try {
      const res = await fetch(`${API_BASE}/api/redeem/${encodeURIComponent(redeemNowCafe.id)}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amountPaid: amount, cafeName: redeemNowCafe.name }),
      });
      const data = await readJsonSafely(res);
      if (!res.ok || !data?.ok) { setRedeemNowError(data?.error || "Failed to redeem. Please try again."); return; }
      setRedeemNowSuccess(true);
    } catch {
      setRedeemNowError("Network error. Please try again.");
    } finally {
      setRedeemNowSubmitting(false);
    }
  };

  const openCafeModal = (cafe) => {
    const normalizedCafe = normalizeSpecials(cafe);
    setSelectedCafe(normalizedCafe);
    setSelectedDrink(normalizedCafe.specials?.[0] || null);
    setActiveCafeTab("about");
    fetch(`${API_BASE}/api/track`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event: "cafe_view", cafeId: cafe.id, cafeName: cafe.name }),
    }).then(async (res) => {
      if (!res.ok) {
        const body = await readJsonSafely(res).catch(() => ({}));
        console.warn("[track] cafe_view failed", res.status, body);
      }
    }).catch((err) => console.warn("[track] cafe_view error", err));
  };

  const closeCafeModal = () => {
    setSelectedCafe(null);
    setSelectedDrink(null);
    setActiveCafeTab("about");
  };

  const goToRedeem = (cafeId) => {
    if (!cafeId || !canRedeemNow) return;
    window.location.href = `/redeem/${encodeURIComponent(cafeId)}`;
  };

  const goToSubscription = () => {
    window.location.href = "/apply/pay";
  };

  const goToPayment = async () => {
    setRedirecting(true);
    try {
      const res = await fetch(`${API_BASE}/api/me/apply-session`, { credentials: "include" });
      const data = await res.json();
      const sessionId = data?.apply_session_id || null;
      const params = new URLSearchParams({ no_trial: "true" });
      if (sessionId) params.set("apply_session_id", sessionId);
      window.location.href = `https://www.fikacreatives.co/apply/pay?${params.toString()}`;
    } catch {
      setRedirecting(false);
    }
  };

  const subscriptionStatus = rewardState.membership?.subscriptionStatus;
  const isNonMember = !loadingReward && !rewardError &&
    (subscriptionStatus === "free" || subscriptionStatus === "trialing");

  const renderPromoCard = () => {
    if (loadingReward) {
      return (
        <section className="promoCard" aria-label="Loading promotion">
          <div className="promoRight" style={{ width: "100%" }}>
            <h3 className="promoHeading">Loading your promotions…</h3>
          </div>
        </section>
      );
    }

    if (rewardError) {
      return (
        <section className="promoCard" aria-label="Promotion error">
          <div className="promoRight" style={{ width: "100%" }}>
            <h3 className="promoHeading">Couldn’t load promotions</h3>
            <p className="promoSubheading">{rewardError}</p>
          </div>
        </section>
      );
    }

    if (rewardState.alreadyRedeemed) {
      return (
        <section className="promoCard promoCardLocked" aria-label="Promotion redeemed">
          <div className="promoLeft">
            <div className="promoLogo" aria-hidden="true">
              <img
                src="https://vdbpbpjwtbcyhnnwynox.supabase.co/storage/v1/object/sign/landing%20page/stamp.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZGI0MGU3NC04Nzk2LTRhZmItOTViNy0wNDQ5YzAyNWMzZjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJsYW5kaW5nIHBhZ2Uvc3RhbXAucG5nIiwiaWF0IjoxNzc2NzE0MzcyLCJleHAiOjE4MDgyNTAzNzJ9.VNfUfVsff3MlSsagGg7TzRxyXi-sLTjVz1KK0xgUPJI"
                style={{ width: "100px", opacity: 0.35, filter: "grayscale(1)" }}
                alt="fika-stamp"
              />
            </div>
          </div>
          <div className="promoRight">
            <h3 className="promoHeading">Promotion no longer available</h3>
            <p className="promoSubheading">
              Check back in for the next promotion.
            </p>
          </div>
        </section>
      );
    }

    if (!showCoupon) {
      return (
        <section className="promoCard" aria-label="No promotions available">
          <h3 className="promoHeading">No visible promotions</h3>
          <p className="promoSubheading">
            Check back later for member rewards.
          </p>
        </section>
      );
    }

    let subheading =
      "You can redeem this offer when you meet for a Fika.";

    if (canRedeemNow) {
      subheading =
        "Redeem at a qualifying cafe to get 20% off your latte or tea.";
    } else if (isMissingPaymentMethod) {
      subheading =
        "Your 20% off reward is reserved for you. Once you're a member, you'll get access to recurring discounts at local cafes around LA.";
    } else if (isTrialLocked) {
      subheading = trialEndsLabel
        ? `Your 20% off reward is reserved for you. It will unlock after your trial ends on ${trialEndsLabel}.`
        : "Your 20% off reward is reserved for you. It will unlock after your 14-day trial ends.";
    }

    return (
      <section
        className={`promoCard ${canRedeemNow ? "" : "promoCardLocked"}`}
        aria-label="Promotion"
      >
        <div className="promoLeft">
          <div className="promoLogo" aria-hidden="true">
            <img
              src="https://vdbpbpjwtbcyhnnwynox.supabase.co/storage/v1/object/sign/landing%20page/stamp.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZGI0MGU3NC04Nzk2LTRhZmItOTViNy0wNDQ5YzAyNWMzZjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJsYW5kaW5nIHBhZ2Uvc3RhbXAucG5nIiwiaWF0IjoxNzc2NzE0MzcyLCJleHAiOjE4MDgyNTAzNzJ9.VNfUfVsff3MlSsagGg7TzRxyXi-sLTjVz1KK0xgUPJI"
              style={{
                width: "100px",
                opacity: canRedeemNow ? 1 : 0.5,
                filter: canRedeemNow ? "none" : "grayscale(0.15)",
              }}
              alt="fika-stamp"
            />
          </div>
        </div>

        <div className="promoRight">
          <h3 className="promoHeading">{promoTitle}</h3>
          <p className="promoSubheading">{subheading}</p>

          <button
            className={`redeemBtn ${canRedeemNow ? "" : "redeemBtnDisabled"}`}
            onClick={handlePromoClick}
            type="button"
          >
            {buttonLabel}
          </button>
        </div>
      </section>
    );
  };

  return (
    <div className="rewardsPage">
      <div className="rewardsContainer">
        {isNonMember ? (
          <section className="promoCard promoCardLocked" aria-label="Member rewards">
            <div className="promoLeft">
              <div className="promoLogo" aria-hidden="true">
                <img
                  src="https://vdbpbpjwtbcyhnnwynox.supabase.co/storage/v1/object/sign/landing%20page/stamp.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9kZGI0MGU3NC04Nzk2LTRhZmItOTViNy0wNDQ5YzAyNWMzZjciLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJsYW5kaW5nIHBhZ2Uvc3RhbXAucG5nIiwiaWF0IjoxNzc2NzE0MzcyLCJleHAiOjE4MDgyNTAzNzJ9.VNfUfVsff3MlSsagGg7TzRxyXi-sLTjVz1KK0xgUPJI"
                  style={{ width: "100px", opacity: 0.4, filter: "grayscale(1)" }}
                  alt="fika-stamp"
                />
              </div>
            </div>
            <div className="promoRight">
              <h3 className="promoHeading">Member rewards</h3>
              <p className="promoSubheading">
                Fika members get 20% off at qualifying cafes around LA — from specialty lattes to seasonal specials. Become a member to start redeeming.
              </p>
              <button
                className="redeemBtn"
                onClick={goToPayment}
                disabled={redirecting}
                type="button"
              >
                {redirecting ? "Loading…" : "Become a member"}
              </button>
            </div>
          </section>
        ) : (
          <>
            {renderPromoCard()}

            <section className="cafesSection" aria-label="Qualifying Cafes">
              <h3 className="sectionHeading">Qualifying Cafes</h3>

              {cafesByCity.map(([city, cityCafes]) => (
                <div key={city} className="cityBlock">
                  <div className="cafeGrid">
                    {cityCafes.map((cafe) => (
                      <article
                        key={cafe.id || cafe.name}
                        className="cafeCard cafeCardInteractive"
                        onClick={() => openCafeModal(cafe)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            openCafeModal(cafe);
                          }
                        }}
                        aria-label={`Open details for ${cafe.name}`}
                      >
                        <div className="cafeMedia">
                          <img
                            className="cafeImage"
                            src={cafe.cafe_image}
                            alt={`${cafe.name} cafe`}
                            loading="lazy"
                          />

                          {cafe.icon_image ? (
                            <img
                              className="cafeIcon"
                              src={cafe.icon_image}
                              alt=""
                              aria-hidden="true"
                            />
                          ) : null}

                          <div className="cafeNameOverlay">
                            <div className="cafeName">{cafe.name}</div>
                            <div className="cafeTapHint">Tap to explore</div>
                          </div>
                        </div>
                      </article>
                    ))}
                  </div>
                </div>
              ))}
            </section>
          </>
        )}
      </div>

      {isRewardModalOpen && canRedeemNow && (
        <Modal onClose={closeRewardModal} ariaLabel="Redeem modal">
          <h3 className="modalTitle">Redeem your reward</h3>
          <p className="modalBody">
            You have an active offer available. Choose a qualifying cafe below
            to continue.
          </p>

          {<div className="modalCafeList">
            {cafes.filter((cafe) => cafe.id !== "bf4af7d7-774c-4818-82e8-f2046bd3870c" && cafe.id !== "the-union-dtla").map((cafe) => (
              <button
                key={cafe.id}
                className="modalCafeOption"
                onClick={() => goToRedeem(cafe.id)}
                type="button"
              >
                {cafe.name}
              </button>
            ))}
          </div> }

          <div className="modalActions">
            <button
              className="modalBtnSecondary"
              onClick={closeRewardModal}
              type="button"
            >
              Cancel
            </button>
          </div>
        </Modal>
      )}

      {isSubscribeModalOpen && (
        <Modal onClose={closeSubscribeModal} ariaLabel="Start membership">
          <h3 className="modalTitle">Unlock your reward</h3>
          <p className="modalBody">
            Your 20% off coffee reward is reserved for you. Start your
            membership by adding your payment method, and your reward will be
            ready once your subscription is set up.
          </p>

          <div className="modalActions">
            <button
              className="redeemBtn"
              onClick={goToSubscription}
              type="button"
            >
              Add payment method
            </button>

            <button
              className="modalBtnSecondary"
              onClick={closeSubscribeModal}
              type="button"
            >
              Close
            </button>
          </div>
        </Modal>
      )}

      {isTrialInfoModalOpen && (
        <Modal onClose={closeTrialInfoModal} ariaLabel="Reward details">
          <h3 className="modalTitle">Your reward is reserved</h3>
          <p className="modalBody">
            {trialEndsLabel
              ? `You’re currently in your 14-day trial. This 20% off reward will unlock after your trial ends on ${trialEndsLabel}.`
              : "You’re currently in your 14-day trial. This 20% off reward will unlock after your trial ends."}
          </p>

          <div className="modalActions">
            <button
              className="modalBtnSecondary"
              onClick={closeTrialInfoModal}
              type="button"
            >
              Got it
            </button>
          </div>
        </Modal>
      )}

      {isRedeemNowModalOpen && (
        <Modal onClose={closeRedeemNowModal} ariaLabel="Redeem now">
          {redeemNowSuccess ? (
            <div style={{ textAlign: "center", padding: "24px 0" }}>
              <p style={{ fontSize: 22, fontWeight: 700, color: "#1a7a47", marginBottom: 8 }}>Redeemed!</p>
              <p style={{ fontSize: 15, color: "#666", marginBottom: 24 }}>
                Enjoy your discount at {redeemNowCafe?.name}.
              </p>
              <button className="redeemBtn" onClick={closeRedeemNowModal} type="button" style={{ width: "100%" }}>
                Done
              </button>
            </div>
          ) : (
            <>
              <h3 className="modalTitle">Redeem your reward</h3>

              <label style={{ display: "block", fontSize: 13, color: "#999", marginBottom: 6, marginTop: 16 }}>
                Select cafe
              </label>
              <div className="modalCafeList" style={{ marginBottom: 20, maxHeight: 200, overflowY: "auto" }}>
                {cafes.filter((c) => c.id !== "bf4af7d7-774c-4818-82e8-f2046bd3870c" && c.id !== "the-union-dtla").map((cafe) => (
                  <button
                    key={cafe.id}
                    className={`modalCafeOption ${redeemNowCafe?.id === cafe.id ? "isActive" : ""}`}
                    onClick={() => setRedeemNowCafe(cafe)}
                    type="button"
                  >
                    {cafe.name}
                  </button>
                ))}
              </div>

              <label style={{ display: "block", fontSize: 13, color: "#999", marginBottom: 6 }}>
                Total at register
              </label>
              <input
                type="number"
                min="0.01"
                step="0.01"
                placeholder="0.00"
                value={redeemNowTotal}
                onChange={(e) => { setRedeemNowTotal(e.target.value); setRedeemNowError(""); }}
                style={{ width: "100%", border: "1px solid #e0dbd4", borderRadius: 12, padding: "14px 16px", fontSize: 17, fontFamily: "inherit", color: "#1a1a1a", boxSizing: "border-box", outline: "none", marginBottom: 20 }}
              />

              {redeemNowError && (
                <p style={{ fontSize: 13, color: "#c0392b", marginBottom: 12 }}>{redeemNowError}</p>
              )}

              <button
                className="redeemBtn"
                onClick={handleRedeemNow}
                disabled={redeemNowSubmitting}
                type="button"
                style={{ width: "100%" }}
              >
                {redeemNowSubmitting ? "Redeeming…" : "Redeem now"}
              </button>
            </>
          )}
        </Modal>
      )}

      {selectedCafe && (
        <Modal
          onClose={closeCafeModal}
          ariaLabel={`${selectedCafe.name} details`}
        >
          <div className="cafeDetailModal">
            <div
              className="cafeDetailHero"
              style={{
                backgroundImage: `url(${selectedCafe.cafe_image})`,
              }}
            >
              <div className="cafeDetailHeroOverlay" />

              {selectedCafe.icon_image ? (
                <img
                  className="cafeDetailHeroIcon"
                  src={selectedCafe.icon_image}
                  alt=""
                  aria-hidden="true"
                />
              ) : null}

              <div className="cafeDetailHeroText">
                <h3 className="modalTitle cafeDetailTitle">
                  {selectedCafe.name}
                </h3>
                <p className="cafeDetailCity">{selectedCafe.city}</p>
              </div>
            </div>

            <div
              className="cafeTabs"
              role="tablist"
              aria-label="Cafe details tabs"
            >
              <button
                className={`cafeTab ${
                  activeCafeTab === "about" ? "isActive" : ""
                }`}
                onClick={() => setActiveCafeTab("about")}
                role="tab"
                aria-selected={activeCafeTab === "about"}
                type="button"
              >
                About
              </button>

              <button
                className={`cafeTab ${
                  activeCafeTab === "specials" ? "isActive" : ""
                }`}
                onClick={() => setActiveCafeTab("specials")}
                role="tab"
                aria-selected={activeCafeTab === "specials"}
                type="button"
              >
                Specials
              </button>

              <button
                className={`cafeTab ${
                  activeCafeTab === "space" ? "isActive" : ""
                }`}
                onClick={() => setActiveCafeTab("space")}
                role="tab"
                aria-selected={activeCafeTab === "space"}
                type="button"
              >
                The Space
              </button>
            </div>

            <div className="cafeTabPanel">
              {activeCafeTab === "about" && (
                <div className="cafeTabContent">
                  <h4 className="cafeTabHeading">About this cafe</h4>
                  <p className="modalBody">
                    {selectedCafe.about || "No cafe details available yet."}
                  </p>
                </div>
              )}

              {activeCafeTab === "specials" && (
                <div className="cafeTabContent">
                  <h4 className="cafeTabHeading">Current specials</h4>

                  {selectedCafe.specials?.length ? (
                    <>
                      <div className="specialDrinkRow">
                        <div className="specialDrinkPreview">
                          <img
                            className="specialDrinkPreviewImage"
                            src={selectedDrink?.image || selectedCafe.cafe_image}
                            alt={selectedDrink?.name || selectedCafe.name}
                          />
                        </div>

                        <div className="specialDrinkInfo">
                          <h5 className="specialDrinkTitle">
                            {selectedDrink?.name || "Featured drink"}
                          </h5>
                          <p className="specialDrinkDescription">
                            {selectedDrink?.description ||
                              "No description available yet."}
                          </p>
                          <p className="specialDrinkExpiration">
                            {selectedDrink?.expiration || ""}
                          </p>
                        </div>
                      </div>

                      <div className="specialsList">
                        {selectedCafe.specials.map((drink) => {
                          const isActive = selectedDrink?.id === drink.id;

                          return (
                            <button
                              key={drink.id}
                              type="button"
                              className={`specialPill ${
                                isActive ? "isActive" : ""
                              }`}
                              onClick={() => setSelectedDrink(drink)}
                              aria-pressed={isActive}
                            >
                              {drink.name}
                            </button>
                          );
                        })}
                      </div>
                    </>
                  ) : (
                    <p className="modalBody">No specials listed yet.</p>
                  )}

                  {canRedeemNow && (
                    <button
                      className="redeemBtn cafeDetailRedeemBtn"
                      onClick={() => goToRedeem(selectedCafe.id)}
                      type="button"
                    >
                      Redeem here
                    </button>
                  )}

                  {!canRedeemNow && isMissingPaymentMethod && (
                    <button
                      className="redeemBtn cafeDetailRedeemBtn redeemBtnDisabled"
                      onClick={() => setIsSubscribeModalOpen(true)}
                      type="button"
                    >
                      Start membership to unlock
                    </button>
                  )}

                  {!canRedeemNow && isTrialLocked && (
                    <button
                      className="redeemBtn cafeDetailRedeemBtn redeemBtnDisabled"
                      onClick={() => setIsTrialInfoModalOpen(true)}
                      type="button"
                    >
                      Available after trial
                    </button>
                  )}
                </div>
              )}

              {activeCafeTab === "space" && (
                <div className="cafeTabContent">
                  <h4 className="cafeTabHeading">The space</h4>
                  <p className="modalBody">
                    {selectedCafe.space?.description ||
                      "No details about the space yet."}
                  </p>

                  {selectedCafe.space?.vibeTags?.length ? (
                    <div className="spaceTagRow">
                      {selectedCafe.space.vibeTags.map((tag) => (
                        <span key={tag} className="spaceTag">
                          {tag}
                        </span>
                      ))}
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </Modal>
      )}

    </div>
  );
}

function Modal({ children, onClose, ariaLabel = "Modal" }) {
  React.useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div
      className="modalBackdrop"
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="modalCard">
        <button
          className="modalClose"
          onClick={onClose}
          aria-label="Close modal"
          type="button"
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
}